import './index.scss';
import './tailwind.css';

import * as Sentry from '@sentry/react';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { applyChunkReloadHandler } from './ChunkReloadHandler';
import { applyDomSafetyPatches } from './DomSafetyPatches';
import { IdelinkCustomerApp, IdelinkLauncher } from './IdelinkLauncher';
import { EnvironmentHelper } from './libs/IdeLink.Web.Common/src/Helpers/EnvironmentHelper';
import { initSentry } from './libs/IdeLink.Web.Common/src/configs/SentryConfig';

export const appName = EnvironmentHelper.isLocalDev() ? IdelinkCustomerApp.DEMOLINK : '__APP__';

applyDomSafetyPatches();
applyChunkReloadHandler();
initSentry(appName);

if (process.env.NODE_ENV !== 'production') {
	const whyDidYouRender = await import('@welldone-software/why-did-you-render');
	whyDidYouRender.default(React);
}

const App = IdelinkLauncher.getApp(appName);

const container = document.getElementById('root');
const root = createRoot(container!, {
	// React swallows render errors caught by error boundaries (incl. React Router's):
	// without these handlers they never reach Sentry, only the console.
	onCaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.error('Caught render error', error, errorInfo.componentStack);
	}),
	onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.error('Uncaught render error', error, errorInfo.componentStack);
	}),
	onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
	<React.StrictMode>
		<Suspense fallback={<></>}>
			<App />
		</Suspense>
	</React.StrictMode>
);
